/**
 * © 2026 iTech India Private Limited. All rights reserved.
 * Licensed under the iTech End User License Agreement (EULA).
 * Unauthorized use or distribution is prohibited.
 */

import { useLocation } from 'react-router-dom';

import type { JSX } from 'react';

/**
 * Placeholder for portal pages whose sprint hasn't landed yet. Replaced
 * route-by-route as S3–S13 deliver real screens. Deliberately renders the
 * current path so QA can confirm routing/guards independently of features.
 */
export function PlaceholderPage(): JSX.Element {
  const { pathname } = useLocation();
  return (
    <div className="flex h-full flex-col items-center justify-center gap-2 p-8 text-center">
      <p className="text-lg font-semibold text-slate-700">Coming soon</p>
      <p className="text-sm text-slate-500">
        <code className="rounded bg-slate-100 px-1.5 py-0.5">{pathname}</code> is scheduled in an
        upcoming sprint.
      </p>
    </div>
  );
}
